import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  cpGetLineOARichMenuList,
  cpCreateLineOARichMenu,
  cpUploadLineOARichMenuImage,
  cpDeleteLineOARichMenu,
  cpSetLineOARichMenuDefault,
  cpClearLineOARichMenuDefault,
} from '@/lib/api/controlPlaneClient'
import { useAuthStore } from '@/lib/store/authStore'

export const LINE_OA_RICH_MENUS_KEY = ['line-oa-rich-menus'] as const

export function useLineOARichMenus(options?: { enabled?: boolean }) {
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  return useQuery({
    queryKey: [...LINE_OA_RICH_MENUS_KEY, activeStorefrontKey],
    queryFn: cpGetLineOARichMenuList,
    staleTime: 2 * 60 * 1000,
    enabled: options?.enabled !== false,
  })
}

export function useCreateRichMenu() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (menuData: object) => cpCreateLineOARichMenu(menuData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LINE_OA_RICH_MENUS_KEY })
    },
  })
}

export function useUploadRichMenuImage() {
  return useMutation({
    mutationFn: ({ richMenuId, file }: { richMenuId: string; file: File }) =>
      cpUploadLineOARichMenuImage(richMenuId, file),
  })
}

export function useDeleteRichMenu() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (richMenuId: string) => cpDeleteLineOARichMenu(richMenuId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LINE_OA_RICH_MENUS_KEY })
    },
  })
}

export function useSetDefaultRichMenu() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (richMenuId: string) => cpSetLineOARichMenuDefault(richMenuId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LINE_OA_RICH_MENUS_KEY })
    },
  })
}

export function useClearDefaultRichMenu() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => cpClearLineOARichMenuDefault(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LINE_OA_RICH_MENUS_KEY })
    },
  })
}
